<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Notify Pros'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      @if (!didCompleteProOnboarding || !didCompleteSmartNumberOnboarding) {
        <tidy-row [align]="'center'" class="extra-bottom-padding">
          <tidy-text
            [body]="'<b>' + ('Please complete the following ' | translate) + ((didCompleteProOnboarding || didCompleteSmartNumberOnboarding) ? ('step' | translate) : ('steps' | translate)) + (' to notify pros of your changes:' | translate) + '</b>'" />
        </tidy-row>
      }
      @if (!didCompleteProOnboarding) {
        <tidy-card class="extra-bottom-padding">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/add-pro-white.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Add Pros'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'Add pros manually or import all of them via CSV.'" />
          </tidy-row>
          <tidy-row>
            <tidy-button
              [text]="'Add Pros'"
              [action]="boundGoToMyProsPage"
              class="secondary" />
          </tidy-row>
        </tidy-card>
      }
      @if (!didCompleteSmartNumberOnboarding) {
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/call-outline.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Add Smart Number'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'Add a smart number to enable SMS communication with your pros.'" />
          </tidy-row>
          <tidy-row>
            <tidy-button
              [text]="'Add Smart Number'"
              [action]="boundGoToSmartNumberPage"
              class="secondary" />
          </tidy-row>
        </tidy-card>
      }
      @if (didCompleteProOnboarding && didCompleteSmartNumberOnboarding) {
        <tidy-row class="extra-bottom-padding" [align]="'center'">
          <tidy-text
            [body]="'We recommend sending your pros a short message notifying them of your changes. Use this to help craft a message:'" />
        </tidy-row>
        <tidy-card>
          <form [formGroup]="form">
            <tidy-row class="card-header">
              <tidy-text
                [header]="'Craft Your Message'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Message to send (you can edit this):'" />
            </tidy-row>
            <div class="message-editor" style="border: 1px solid var(--ion-border-color); border-radius: 8px; padding: 12px; background-color: var(--ion-card-background); margin: 15px 0;">
              <ion-textarea
                formControlName="messageText"
                placeholder="Your message will appear here..."
                [autoGrow]="true"
                [rows]="10"
                class="message-textarea"
                style="--background: var(--ion-card-background); border: none; border-radius: 4px; padding: 10px;" />
            </div>
          </form>
        </tidy-card>
        <tidy-card>
          <tidy-row class="card-header">
            <tidy-text
              [header]="'Select How to Send'" />
          </tidy-row>
          <form [formGroup]="form">
            <tidy-radio-button
              [items]="howToSendItems"
              [form]="form.controls.howToSend"
              formControlName="howToSend" />
          </form>
          @if (form.value.howToSend == 'copy') {
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="'Copy Message'"
                class="link"
                (action)="copyMessage(this)" />
              @if (messageCopied) {
                <tidy-text
                  style="margin-left:5px"
                  [helper]="'Copied'" />
              }
            </tidy-row>
          }
        </tidy-card>
        <tidy-card>
          <tidy-row class="card-header">
            <tidy-text
              [header]="'Select Pros to Send to'" />
          </tidy-row>
          @for (pro of allProItems; track pro) {
            <tidy-checkbox
              [initValue]="true"
              [form]="form.controls.pro"
              [items]="[{viewValue: pro.viewValue , value: true}]"
              (checkedChange)="updateSelectedPros(pro)" />
          }
        </tidy-card>
        @if (form.value.howToSend == 'sms') {
          <tidy-button
            [text]="'Send SMS to Pros'"
            [action]="boundSendSMSToPros"
            class="secondary"
            style="margin-bottom: 10px;" />
        }
        @if (form.value.howToSend == 'copy') {
          <tidy-button
            [text]="'Mark Step Complete'"
            [action]="boundMarkStepComplete"
            class="secondary"
            style="margin-bottom: 10px;" />
        }
        <!-- Show sending progress -->
        @if (sendingInProgress) {
          <div class="sending-progress">
            <h3>Sending messages to pros...</h3>
            <div class="pro-list">
              @for (item of prosSendStatus; track item) {
                <div class="pro-item">
                  <span class="pro-name">{{ item.pro.name || 'Unknown Pro' }}</span>
                  <span class="pro-status" [ngClass]="'status-' + item.status">
                    @switch (item.status) {
                      @case ('pending') {
                        <span>⏳ Waiting</span>
                      }
                      @case ('sending') {
                        <span>📤 Sending...</span>
                      }
                      @case ('success') {
                        <span>✅ Sent</span>
                      }
                      @case ('error') {
                        <span>❌ Failed{{ item.error ? ': ' + item.error : '' }}</span>
                      }
                    }
                  </span>
                </div>
              }
            </div>
          </div>
        }
      }
    }

    @if (!loaded) {
      <ion-skeleton-text animated="true" style="width: 100%; height: 400px" />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
